import { render } from "./Arrow.vue?vue&type=template&id=142e7909"
const script = {}
script.render = render

export default script